import { render, staticRenderFns } from "./LoadGrey.vue?vue&type=template&id=dbfc1552"
import script from "./LoadGrey.vue?vue&type=script&lang=js"
export * from "./LoadGrey.vue?vue&type=script&lang=js"
import style0 from "./LoadGrey.vue?vue&type=style&index=0&id=dbfc1552&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports